import React, {FC} from "react"

import id from "@irati/utils/id"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"

import Flex from "../Flex"
import {Body, H2} from "../Typography"
import Anchor from "../Link/styled/Anchor"
import Http403Svg from "./Http403.svg"

import {ErrorImg} from "./styled/Http403"

interface Props extends InjectIntl {
  id?: string
}

const Http403: FC<Props> = (props) => {
  const idNamespace = id("Http403", props)

  return (
    <div id={idNamespace}>
      <Flex id={id("wrapper", idNamespace)} direction="column" justifyContent="center" alignItems="center" padding={3}>
        <ErrorImg src={Http403Svg} alt="Error" />
        <H2 id={id("title", idNamespace)} margin={[2, 0]}>
          <FormattedMessage id="platform.http403.error.header" />
        </H2>
        <Body id={id("subtitle", idNamespace)}>
          <FormattedMessage
            id="platform.http403.error.subtitle"
            values={{
              url: (
                <Anchor href={props.formatMessage({id: "platform.http403.error.pbHref"})} target="_BLANK">
                  <FormattedMessage id="platform.http403.error.href.text" />
                </Anchor>
              )
            }}
          />
        </Body>
      </Flex>
    </div>
  )
}

Http403.defaultProps = {
  id: "http-403"
}

export default injectIntl(Http403)
